import { QuestionHelper, Balance, Box, Button, Dots, Flex, FlexGap, IconButton, Modal, OpenNewIcon, Text, useToast } from "@pancakeswap/uikit"
import { useCallback, useState, useEffect } from "react"
import styled, { keyframes, css } from "styled-components"
import { useAccount } from "wagmi"
import { useSignMessage } from "@pancakeswap/wagmi"
import { formatUnits } from "viem"
import { useCurrency } from "hooks/Tokens"
import axios, { AxiosError } from "axios"
import { LOOT_BOX_API } from "config/constants/endpoints"
import { useLootBoxContract } from "hooks/useContract"
import useCatchTxError from "hooks/useCatchTxError"
import { calculateGasMargin } from "utils"
import { formatNumber } from "@pancakeswap/utils/formatBalance"
import { POINTS_PER_BOX } from "config/constants"
import useSWRImmutable from "swr/immutable"
import { isUserRejected } from "utils/sentry"
import { useActiveChainId } from "hooks/useActiveChainId"
import { useCustomToast } from "state/transactions/hooks"
import ConnectedWallet from "./ConnectedWallet"
import { TransactionSubmittedContent } from "./TransactionConfirmationModal"



const Divider = styled.hr`
    width: 100%;
    border-width: 1px 0 0 0;
    border-color: #FFF4;
    margin-top: 18px;
    margin-bottom: 24px;
`

const ShareButton = styled(Button)`
    justify-content: flex-start;
    gap: 24px;
    min-height: 72px;
    margin-top: 24px;
    background: #2B2634;
`

const fadeInDiagonal = keyframes`
    0% {
        opacity: 0;
        transform: translate(-100px, 100px);
    }
    100% {
        opacity: 1;
        transform: translate(0, 0);
    }
`

const pulsateGold = keyframes`
    0% {
        box-shadow: 0 0 0 0 rgba(255, 215, 0, 0.8);
        transform: scale(1);
    }
    50% {
        box-shadow: 0 0 0 10px rgba(255, 215, 0, 0.3);
        transform: scale(1.1);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 215, 0, 0);
        transform: scale(1);
    }
`

const TwitterText = styled(Text)`
    position: fixed;
    top: 15%;
    right: calc(50% - 250px);
    z-index: 10000;
    font-size: 18px;
    font-weight: bold;
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    pointer-events: none;
    animation: ${fadeInDiagonal} 1s ease-out forwards;
    white-space: nowrap;
    transform: rotate(-15deg);
`

const PulsatingIconButton = styled(IconButton) <{ animate?: boolean }>`
    ${({ animate }) => animate && css`
        animation: ${pulsateGold} 2s infinite;
        border-radius: 50%;
    `}
    position: relative;
`

const Tooltip = styled.div`
    position: absolute;
    bottom: 100%;
    right: 0;
    background: rgba(44, 47, 54, 0.95);
    color: white;
    padding: 12px 16px;
    border-radius: 12px;
    font-size: 13px;
    white-space: nowrap;
    z-index: 10001;
    margin-bottom: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &::after {
        content: '';
        position: absolute;
        top: 100%;
        right: 16px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid rgba(44, 47, 54, 0.95);
    }
`

const TooltipText = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    
    &::before {
        content: '⚡';
        color: #FFD700;
        font-size: 14px;
    }
`

const Icon = ({ color, size }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99996 12.3337V8.33366M8.99996 6.33366V6.32699M16.3333 9.00033C16.3333 13.0504 13.05 16.3337 8.99996 16.3337C4.94987 16.3337 1.66663 13.0504 1.66663 9.00033C1.66663 4.95024 4.94987 1.66699 8.99996 1.66699C13.05 1.66699 16.3333 4.95024 16.3333 9.00033Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
        </svg>
    );
};

export const PrizeModal = ({ mode, onDismiss }: { mode?: string, onDismiss?: () => void }) => {
    const { address } = useAccount()
    const { chainId } = useActiveChainId()
    const [open, setOpen] = useState<string>(mode)
    const [attempting, setAttempting] = useState(false)
    const [tokens, setTokens] = useState<number>()
    const [unclaimed, setUnclaimed] = useState<number>()
    const [txHash, setTxHash] = useState<`0x${string}`>()
    const [showTwitterText, setShowTwitterText] = useState(false)
    const [showTooltip, setShowTooltip] = useState(false)

    const { signMessageAsync } = useSignMessage()

    // const { isDesktop } = useMatchBreakpoints()

    const pDEX = useCurrency('0x41654eC146BB9ffD39efb73e81B0dFC908631232')

    const lootBox = useLootBoxContract()
    const { fetchTxResponse } = useCatchTxError()
    const { toastCustom } = useToast()
    const { toastRejection } = useCustomToast()

    const { data: reward, mutate } = useSWRImmutable(['reward/me', address])

    useEffect(() => {
        if (tokens && tokens > 0 && open === 'bonus') {
            setShowTwitterText(true)
        } else {
            setShowTwitterText(false)
        }
    }, [tokens, open])

    const toastError = useCallback((title, message) => {
        toastCustom(
            <FlexGap gap="12px" p="12px" alignItems="flex-start">
                <Box bg="#EEA23E1A" borderRadius={9} p="12px">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8V14M12 17V17.01M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" stroke="#EEA23E" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </Box>
                <Box>
                    <Text color="white">{title}</Text>
                    <Text fontSize={18}>{message}</Text>
                </Box>
            </FlexGap>
        )
    }, [toastCustom])

    const handleOpen = async () => {
        setOpen(undefined)
        setAttempting(true)
        try {
            const { data: nonceData } = await axios.get(`${LOOT_BOX_API}/nonce/${address}`)
            const signature = await signMessageAsync({
                message: nonceData.message
            })
            const { data: openResult } = await axios.post(`${LOOT_BOX_API}/open/${address}`, { signature, nonce: nonceData.nonce })
            if (openResult.success) {
                setTokens(Number(openResult.amount))
                setUnclaimed(Number(openResult.unclaimed))
                setOpen('bonus')
                mutate({
                    points: reward.points - POINTS_PER_BOX,
                    unclaimed: Number(openResult.unclaimed)
                })
            }
        } catch (ex) {
            if (isUserRejected(ex))
                toastRejection()
            else
                toastError('Buy Loot Box', ex instanceof AxiosError ? ex.response.data.message : (ex as any).message)
            console.error(ex)
        } finally {
            setAttempting(false)
        }
    }

    const handleClaim = async () => {
        setAttempting(true)
        try {
            const { data: signData } = await axios.get(`${LOOT_BOX_API}/sign/${address}`)
            const { boxIds, availableBoxes, amount, deadline, claimId, signature } = signData
            await lootBox.estimateGas.claim([boxIds, amount, deadline, claimId, signature], {}).then(async gas => {
                await fetchTxResponse(() =>
                    lootBox.write.claim(
                        [boxIds, amount, deadline, claimId, signature],
                        { gas: calculateGasMargin(gas) }
                    ), {
                    summary: "Claim",
                    translatableSummary: {
                        text: 'Claimed %amount% %symbol% from Loot Box',
                        data: {
                            amount: Number(formatUnits(BigInt(amount), 18)).toFixed(0),
                            symbol: 'VISION'
                        },
                    },
                    type: 'claim-loot',
                }).then((tx) => {
                    if (tx) {
                        setOpen('add')
                        setTxHash(tx.hash)
                        axios.get(`${LOOT_BOX_API}/claim/${tx.hash}`)
                    } else
                        setOpen('claim')
                })
            }).catch(ex => {
                toastError('Claim Loot Box', ex.shortMessage)
            })
        } catch (ex) {
            toastError('Claim Loot Box', ex instanceof AxiosError ? ex.response.data.message : ex)
        } finally {
            setAttempting(false)
        }
    }

    if (open === 'bonus' || open === 'claim') {
        return (
            <>
                {showTwitterText && (
                    <TwitterText>
                        Share on twitter and get a FREE box
                    </TwitterText>
                )}
                <Modal title={undefined} minWidth={["100%", "100%", 400]}>
                    <div style={{ position: 'relative' }}>
                        {
                            tokens > 0 &&
                            <Flex justifyContent="flex-end">
                                <PulsatingIconButton
                                    variant="text"
                                    style={{ padding: 8, width: 'fit-content', height: 'fit-content' }}
                                    onClick={() => setOpen('share')}
                                    animate={true}
                                    onMouseEnter={() => setShowTooltip(true)}
                                    onMouseLeave={() => setShowTooltip(false)}
                                >
                                    {showTooltip && (
                                        <Tooltip>
                                            <TooltipText>
                                                Share on X and keep your post up for 24h to earn 3 points (1 free loot box).
                                            </TooltipText>
                                        </Tooltip>
                                    )}
                                    <img src="/images/share.png" height={18} alt="" />
                                </PulsatingIconButton>
                                <QuestionHelper placement="top"
                                    icon={<Icon color="#B99BF4" size={16} />}
                                    text={
                                        <Text>✨ Share on X and keep your post up for 24h to earn 3 points (1 free loot box).</Text>
                                    }
                                />
                            </Flex>

                        }
                        <FlexGap flexDirection="column" gap="8px" alignItems="center">
                            {
                                tokens > 0
                                    ? <>
                                        <Flex justifyContent="center" pt={attempting ? 4 : 1} pb={3}>
                                            {
                                                attempting
                                                    ? <ConnectedWallet height={180} />
                                                    : <img src="/images/bonus.png" height={220} alt="" />
                                            }
                                        </Flex>
                                        {
                                            attempting
                                                ? <>
                                                    <FlexGap gap="8px">
                                                        <Balance fontSize={32} bold value={unclaimed} decimals={0} />
                                                        <Text fontSize={32} bold>$VISION</Text>
                                                    </FlexGap>
                                                    <Text color="textSubtle" fontSize={[13, 14, 15]}>Confirm claiming in your wallet</Text>
                                                </>
                                                : <>
                                                    <Flex alignItems="center" flexDirection="column">
                                                        <FlexGap gap="8px">
                                                            <Balance fontSize={32} bold value={tokens} decimals={0} />
                                                            <Text fontSize={32} bold>$VISION</Text>
                                                        </FlexGap>
                                                        {
                                                            tokens < unclaimed &&
                                                            <FlexGap gap="8px">
                                                                <Text fontSize={18}>Total:</Text>
                                                                <Balance fontSize={18} value={unclaimed} decimals={0} />
                                                                <Text fontSize={18}>$VISION</Text>
                                                            </FlexGap>
                                                        }
                                                    </Flex>
                                                    <Text color="textSubtle" fontSize={[13, 14, 15]}>You have received a reward!</Text>
                                                </>
                                        }
                                        <Button onClick={handleClaim} disabled={attempting} width="100%" minHeight="72px" mt={2}>
                                            {
                                                attempting
                                                    ? <Dots>Claiming</Dots>
                                                    : "Claim"
                                            }
                                        </Button>
                                    </>
                                    : open === 'claim'
                                        ? <>
                                            <Flex justifyContent="center" pt={attempting ? 4 : 1} pb={3}>
                                                {
                                                    attempting
                                                        ? <ConnectedWallet height={180} />
                                                        : <img src="/images/bonus.png" height={220} alt="" />
                                                }
                                            </Flex>
                                            <FlexGap gap="8px">
                                                <Balance fontSize={32} bold value={reward.unclaimed} decimals={0} />
                                                <Text fontSize={32} bold>$VISION</Text>
                                            </FlexGap>
                                            {
                                                attempting
                                                    ? <Text color="textSubtle" fontSize={[13, 14, 15]}>Confirm claiming in your wallet</Text>
                                                    : <Text color="textSubtle" fontSize={[13, 14, 15]}>You have unclaimed reward!</Text>
                                            }
                                            <Button onClick={handleClaim} disabled={attempting} width="100%" minHeight="72px" mt={2}>
                                                {
                                                    attempting
                                                        ? <Dots>Claiming</Dots>
                                                        : "Claim"
                                                }
                                            </Button>
                                        </>
                                        : <>
                                            <Flex justifyContent="center">
                                                <img src="/images/noreward.png" height={180} alt="" />
                                            </Flex>
                                            <Text fontSize={32} bold>No Reward</Text>
                                            <Text color="textSubtle" fontSize={[13, 14, 15]}>Better luck next time!</Text>
                                            <FlexGap gap="8px" width="100%">
                                                <Button onClick={onDismiss} variant="subtle" width="100%" minHeight="72px" mt={2}>
                                                    Close
                                                </Button>
                                                <Button onClick={handleOpen} width="100%" minHeight="72px" mt={2}>
                                                    Retry
                                                </Button>
                                            </FlexGap>
                                        </>
                            }
                        </FlexGap>
                    </div>
                </Modal>
            </>
        )
    }

    if (open === 'share') {
        return <Modal title="Share" minWidth={["100%", "100%", 400]} onDismiss={() => setOpen('bonus')}>
            <img src="/images/share-logo.png" alt="" />
            <Divider />
            <Text fontSize={18}>Share to</Text>
            <ShareButton onClick={() => {
                const tweetText = `I just pulled ${tokens} $VISION tokens for free on pDEX.vision 🔥\nLoot box opened. Bags filled.\n#VISION`;
                const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
                window.open(tweetUrl, '_blank', 'noopener,noreferrer');
            }}>
                <OpenNewIcon color="textSubtle" />
                <Text color="textSubtle" fontSize={18}>Share</Text>
            </ShareButton>
        </Modal>
    }

    if (open === 'add') {
        return <Modal title="">
            <TransactionSubmittedContent
                chainId={chainId}
                hash={txHash}
                onDismiss={() => {
                    onDismiss?.()
                }}
                currencyToAdd={pDEX}
            />
        </Modal>
    }

    return <Modal title={undefined} minWidth={["100%", "100%", 400]}>
        {/* <Flex justifyContent="flex-end">
            <IconButton variant="text" style={{ padding: 0, width: 'fit-content', height: 'fit-content' }}>
                <img src="/images/share.png" height={18} alt="" />
            </IconButton>
        </Flex> */}
        <FlexGap flexDirection="column" gap="8px" alignItems="center">
            <Flex justifyContent="center" pt={attempting ? 4 : 0} pb={attempting ? 3 : 0}>
                {
                    attempting
                        ? <ConnectedWallet height={180} />
                        : <img src="/images/lootbox.png" alt="" />
                }
            </Flex>
            <Text fontSize={32} bold>Buy Loot Box</Text>
            {
                attempting
                    ? <Text color="textSubtle" fontSize={[13, 14, 15]}>Confirm opening in your wallet</Text>
                    : <Flex flexDirection="column">
                        <Text color="textSubtle" textAlign="center" fontSize={[13, 14, 15]}>Spend your points to open a loot box and<br /> earn exclusive rewards.</Text>
                        <Text color="textSubtle" textAlign="center" fontSize={[13, 14, 15]}>Each loot box costs {formatNumber(POINTS_PER_BOX, 0)} points.</Text>
                    </Flex>
            }
            <Button onClick={handleOpen} disabled={attempting} width="100%" minHeight="72px" mt={2}>
                {
                    attempting
                        ? <Dots>Buying</Dots>
                        : "Buy"
                }
            </Button>
        </FlexGap>
    </Modal>
}